import { Map, Marker } from '@vis.gl/react-google-maps';

import GoogleMapBounder from './GoogleMapBounder';
import React from 'react';

const KKMapMarkerPath = '/images/kk-map-marker.svg';

export interface mapProps {
	name?: string;
	latitude: number;
	longitude: number;
}
interface props {
	locations: mapProps[];
}

export default function GoogleMapInner({ locations }: props) {
	const defaultProps = {
		center: {
			lat: locations[0].latitude,
			lng: locations[0].longitude,
		},
		zoom: 11,
	};

	return (
		<Map
			defaultCenter={defaultProps.center}
			defaultZoom={defaultProps.zoom}
			disableDefaultUI={true}
			minZoom={1}
			maxZoom={16}
			zoomControl={true}
			styles={[
				{
					featureType: 'poi',
					elementType: 'labels',
					stylers: [{ visibility: 'off' }],
				},
			]}
		>
			<GoogleMapBounder locations={locations} />
			{locations.map((place) => (
				<Marker
					key={`${place.latitude}-${place.longitude}`}
					title={place.name}
					position={{ lat: place.latitude, lng: place.longitude }}
					icon={KKMapMarkerPath}
				/>
			))}
		</Map>
	);
}
